<!--
 * @Author: Src
 * @Date: 2025-05-14 09:04:57
 * @LastEditTime: 2025-05-15 00:14:23
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/privacy/index.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div class="privacy-container">
        <div v-if="privacyAll">
            <div class="privacy-title">
                <h1>实名信息</h1>
            </div>
            <div class="privacy-phone" v-if="privacyEdit">
                <span>识别到您需要认证的号码是:<span class="privacy-phone-number">{{ phoneData.phone }}</span>，请确认是否为该号码进行认证，如非该号码，请联系客服修改</span>
            </div>
            <div class="privacy-form" v-if="privacyEdit">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
                    <div class="privacy-form-title">店铺名称</div>
                    <el-form-item>
                        {{ phoneData.shop_name }}
                    </el-form-item>
                    <div class="privacy-form-title"><i class="red-star">*</i>姓名</div>
                    <el-form-item prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <div class="privacy-form-title"><i class="red-star">*</i>证件类型</div>
                    <el-form-item>
                        <el-select v-model="certificate_type" placeholder="请选择" style="width: 100%;">
                            <el-option label="身份证" value="1"></el-option>
                            <!-- <el-option label="护照" value="2"></el-option>
                            <el-option label="驾驶证" value="3"></el-option>
                            <el-option label="行驶证" value="4"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <div class="privacy-form-title"><i class="red-star">*</i>证件号码</div>
                    <el-form-item prop="certificate_no" required>
                        <el-input v-model="ruleForm.certificate_no"></el-input>
                    </el-form-item>
                    <div v-if="phoneData.phone_type == 2" class="privacy-form-title"><i
                            class="red-star">*</i>用户类型</div>
                    <el-form-item prop="custom_type" v-if="phoneData.phone_type == 2">
                        <el-select v-model="ruleForm.custom_type" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="privacy-form-title"><i class="red-star">*</i>正面人像照</div>
                    <el-form-item prop="user_photo">
                        <up-load @success="handleAvatarSuccess" :type="'user_photo'" :text="'正面人像照'"
                            :auth_code="code"></up-load>
                        <div>
                            <span @click="showExample(headImg)">查看示例</span>
                        </div>
                        <div class="privacy-tips">
                            支持jpg、png、jpeg格式，大小不超过1MB<br>
                            图片清晰,人脸无遮挡
                        </div>
                    </el-form-item>
                    <el-form-item label="身份证正反面图片" label-width="140px" v-if="false">
                    </el-form-item>
                    <el-form-item v-if="false">
                        <div>
                            <up-load @success="handleAvatarSuccess" :text="'身份证人像面'" :auth_code="code"></up-load>
                            <span @click="showExample(portraitID)">查看示例</span>
                        </div>
                        <div>
                            <up-load @success="handleAvatarSuccess" :text="'身份证国徽面'" :auth_code="code"></up-load>
                            <span @click="showExample(nationalEmblemID)">查看示例</span>
                        </div>
                        <div class="privacy-tips">
                            支持jpg、jpeg格式的图片，每张图片不大于1MB<br>
                            请保持身份证居中无遮挡，否则不易通过审核
                        </div>
                    </el-form-item>
                </el-form>
                <div class="privacy-footer">
                    <div class="privacy-tips"><i
                            class="el-icon-warning-outline"></i>应国家实名制要求，高德将收集您的上述身份信息，并将前述信息提供给运营商用作实名校验</div>
                    <div class="privacy-footer-btn">
                        <el-button type="primary" @click="submit" class="_submit">提交</el-button>
                    </div>
                </div>
                <img-viewer :url-list="srcList" v-if="showViewer" :on-close="closeViewer"></img-viewer>
            </div>
            <div class="privacy-success" v-else>
                <el-result icon="success" title="成功提示" subTitle="已提交，请耐心等待审核">
                    <template slot="extra">
                    </template>
                </el-result>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator';
import portraitID from '@/assets/img/portraitID.png';
import nationalEmblemID from '@/assets/img/nationalEmblemID.png';
import headImg from '@/assets/img/headImg.png';
import imgViewer from './img-viewer.vue';
import upLoad from './upLoad.vue';
import lazyInject from '@/di';
import PrivacyService from '@/services/privacy.service';
@Component({
    components: {
        imgViewer,
        upLoad
    }
})
export default class Privacy extends Vue {
    phone = '13899996666';
    portraitID = portraitID;
    nationalEmblemID = nationalEmblemID;
    headImg = headImg;
    srcList = [portraitID];
    certificate_type = '1';
    ruleForm: any = {
        code: '',
        name: '',
        certificate_no: '',
        user_photo: '',
        custom_type: '',
    }
    rules = {
        name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        certificate_no: [
            { equired: true, validator: this.validatePass, trigger: 'blur' },
        ],
        custom_type: [
            { required: true, message: '请选择用户类型', trigger: 'blur' }
        ],
        user_photo: [
            { required: true, message: '请上传正面人像照', trigger: 'blur' }
        ]
    }
    code = '';


    @Ref('ruleForm')
    ruleRefForm!: any;

    privacyEdit = true;

    privacyAll = false;

    phoneData: any = {};

    @lazyInject(PrivacyService)
    private privacyService!: PrivacyService;

    validatePass(rule: any, value: any, callback: any) {
        console.log(value);
        if (!value) {
            callback(new Error('请输入证件号码'));
        } else if (!/^\d{17}(\d|x|X)$/.test(value)) {
            callback(new Error('请输入正确的身份证号码'));
        } else {
            callback();
        }
    }
    options = [
        {
            value: '1',
            label: '法定代表人'
        },
        {
            value: '2',
            label: '经办人'
        }
    ]
    showViewer = false;
    imageUrl = '';
    closeViewer() {
        this.showViewer = false;
    }
    handleAvatarSuccess(res: any, type: string) {
        this.ruleForm[type] = res.id;
    }
    beforeAvatarUpload(file: any) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
        }
    }
    showExample(url: string) {
        this.srcList = [url];
        this.showViewer = true;
    }
    submit() {
        console.log(this.ruleForm);
        this.ruleRefForm.validate((valid: any) => {
            if (valid) {
                console.log(this.ruleForm);
                this.editAuth();
            } else {
                console.log('error submit!!');
            }
        });
    }

    async editAuth() {
        const res = await this.privacyService.editAuth(this.ruleForm);
        console.log(res, 'res');
        if (res) {
            this.privacyEdit = false;
        }
    }
    mounted() {
        const { code } = this.$route.params;
        this.code = code;
        this.ruleForm.code = code;
        this.getAuthInfo();
    }
    async getAuthInfo() {
        try {
            const res = await this.privacyService.getAuthInfo({ code: this.code });
            this.privacyAll = true;
            if (res) {
                if (res.data && Object.keys(res.data).length > 0) {
                    this.phoneData = res.data;
                } else {
                    this.privacyEdit = false;
                }
            } else {
                this.privacyAll = false;
            }
        } catch (error) {
            console.log(error, 'error');
        }
    }

}
</script>

<style lang="scss" scoped>
.privacy-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    padding: 20px;
    border-bottom: 1px solid #ccc;
}

.privacy-phone-number {
    color: #000;
    font-weight: bold;
    font-size: 16px;
}

.privacy-phone {
    font-size: 16px;
    margin-bottom: 20px;
    padding: 0 20px;
}

.privacy-form {
    padding: 20px;
}

.privacy-container {
    height: 100%;
    overflow-y: auto;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
}

.privacy-footer {

    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    .privacy-footer-btn {

        text-align: center;

        ._submit {
            margin-top: 20px;
            width: 300px;
        }
    }
}

.privacy-tips {
    font-size: 12px;
    line-height: 20px;
    color: #999;
}

.red-star {
    color: red;
    margin-right: 5px;
}

.privacy-form-title {
    font-size: 14px;
    padding:5px 0 10px 0;
    box-sizing: border-box;
}
</style>
